module.exports = __webpack_public_path__ + "layout_com6.jpg?545a04853ae2c4704e9a29c08c869966";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layouts/layout_com6.jpg
// module id = 86
// module chunks = 0